import { render } from "./PortalMessage.vue?vue&type=template&id=81bb57cc&scoped=true"
import script from "./PortalMessage.vue?vue&type=script&lang=js"
export * from "./PortalMessage.vue?vue&type=script&lang=js"

import "./PortalMessage.vue?vue&type=style&index=0&id=81bb57cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81bb57cc"]])

export default __exports__